import { ReportStatuses } from '@schooly/api';

export const REPORT_STATUS_TEXT_ID: { [k in ReportStatuses]: string } = {
  [ReportStatuses.Draft]: 'status-Draft',
  [ReportStatuses.Published]: 'status-Published',
  [ReportStatuses.Unpublished]: 'status-NotPublished',
};
